import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

// Protects routes - redirects to login if not authenticated
// Optionally restricts to specific roles
// Usage: <ProtectedRoute allowedRoles={["PMO", "Admin"]} />
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, userRole, loading } = useAuth();
  const location = useLocation();

  // Wait for auth to initialize before making redirect decisions
  if (loading) return null;

  // Not logged in - save intended URL then redirect to login page
  if (!isAuthenticated) {
    sessionStorage.setItem("psi360_return_to", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // Logged in but role not allowed for this route
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;